module.exports = __webpack_public_path__ + "img/help_dataset_celltype.cf3f2a14.png";